import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
export const saveDataLakeConnector = async (connector) => {
  try {
    const { id } = await fetch(
      "POST",
      qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials/save`),
      connector
    );
    UserNotification.success(`Data Lake Connector saved successfully.`);
    return id;
  } catch (errorThrown) {
    UserNotification.error(
      `Saving Data Lake Connector failed with status: ${errorThrown}`,
      "Could not save the Data Lake Connector."
    );
  }
  return null;
};
export const deleteDataLakeConnector = async (id) => {
  try {
    await fetch(
      "DELETE",
      qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials/${id}`)
    );
    UserNotification.success(`Data Lake Connector deleted successfully.`);
  } catch (errorThrown) {
    UserNotification.error(
      `Deleting Data Lake Connector failed with status: ${errorThrown}`,
      "Could not delete the Data Lake Connector."
    );
  }
};
export const fetchDataLakeConnectors = async () => fetch(
  "GET",
  qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials`)
);
export const DataLakeConnectorsQueryKey = "data-lake-connectors";
const useDataLakeConnectors = (refetchInterval = 5e3) => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: [DataLakeConnectorsQueryKey],
    queryFn: () => defaultOnError(
      fetchDataLakeConnectors(),
      "Loading Data Lake Connectors failed with status",
      "Could not load Data Lake Connectors."
    ),
    notifyOnChangeProps: ["data", "error"],
    refetchInterval
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeConnectors;
